import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface Notification {
  id: string;
  title: string;
  message: string;
  type: "success" | "warning" | "info" | "error";
  timestamp: string;
  isRead: boolean;
}

export type ModalType =
  | "login"
  | "otpVerify"
  | "forgotPassword"
  | "resetLinkSent"
  | "resetPassword"
  | "register"
  | "verifyAccount"
  | "verifyEmail"
  | "contactUs"
  | "playInfo"
  | "categorySuggestion"
  | "support"
  | "deleteAccount"
  | null;

export const VALID_MODAL_TYPES: ModalType[] = [
  "login",
  "otpVerify",
  "forgotPassword",
  "resetLinkSent",
  "resetPassword",
  "register",
  "verifyAccount",
  "verifyEmail",
  "contactUs",
  "playInfo",
  "categorySuggestion",
  "support",
  "deleteAccount",
];

interface ModalState {
  isOpen: boolean;
  modalType: ModalType;
}

interface UIState {
  modal: ModalState;
}

const initialState: UIState = {
  modal: {
    isOpen: false,
    modalType: null,
  },
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openModal(state, action: PayloadAction<ModalType>) {
      state.modal.isOpen = true;
      state.modal.modalType = action.payload;
    },
    closeModal(state) {
      state.modal.isOpen = false;
      state.modal.modalType = null;
    },
    setModalType(state, action: PayloadAction<ModalType>) {
      state.modal.modalType = action.payload;
    },
  },
});

export const { openModal, closeModal, setModalType } = uiSlice.actions;
export default uiSlice.reducer;
